import React from 'react';

import cn from 'classnames';

import { IRequestMaterialSinglePosition, IRequestMaterialStage } from '@entities/requestMaterial';
import { RequestsTableBody, RequestsTableHeader } from '@features/AddRequestMaterialModal/ui';
import { Flex } from '@shared/ui';

import cls from './RequestsTable.module.css';

interface RequestsTableProps {
    stages: IRequestMaterialStage[];
    search: string;
    manualPositions: IRequestMaterialSinglePosition[];
    classes?: string;
}

export const RequestsTable = ({ stages, search, manualPositions, classes }: RequestsTableProps) => {
    return (
        <Flex direction="column" fullWidth className={cn(cls.RequestsTable, [classes])}>
            <RequestsTableHeader classes={cls.row} />
            <RequestsTableBody search={search} manualPositions={manualPositions} />
        </Flex>
    );
};
